import { lazy } from 'react'

export const DataSourceInstancePageLazy = lazy(() => import('./DataSourceInstances'))
